<template>
  <v-autocomplete
    :label="label"
    :value="value"
    :items="options"
    :item-text="getItemText"
    :no-data-text="
      !!searchingInput && !(isTyping || isSerching)
        ? (noDataText || $t('components.NO_RESULTS'))
        : (placehoder || $t('components.SEARCH_PLACEHOLDER'))
    "
    outlined
    v-bind="$attrs"
    clearable
    @focus="searchOnFocus && doAutocompleteSearch()"
    @input="handleSelect"
    @update:search-input="handleInput"
  >
    <template #append>
      <Async
        :loading="isTyping || isSerching"
        inline
      >
        <v-icon>mdi-menu-down</v-icon>
      </Async>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    api: {
      type: Function,
      default: () => {}
    },
    limit: {
      type: Number,
      default: 20
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    noDataText: {
      type: String,
      default: ''
    },
    placehoder: {
      type: String,
      default: ''
    },
    searchOnFocus: {
      type: Boolean,
      default: true
    },
    default: {
      type: String,
      default: ''
    },
    keyName: {
      type: String,
      default: 'id'
    },
    textName: {
      type: String,
      default: 'name'
    },
    exclude: {
      type: [String, Array],
      default: null
    },
    /** API 回傳的 name/code 對應 i18n key，選項會依語系顯示 */
    textKeyMap: {
      type: Object,
      default: () => ({})
    },
    /** 用於 textKeyMap 的欄位（若 API 有 code 可改用 'code'） */
    mapKeyField: {
      type: String,
      default: 'name'
    }
  },
  data() {
    return {
      isTyping: false,
      typingBuffer: null,
      isSerching: false,
      searchingInput: '',
      options: []
    };
  },
  methods: {
    getItemText(i) {
      if (!i) return '';
      return i.textKey ? this.$t(i.textKey) : (i.text || '');
    },
    handleSelect(v) {
      this.$emit('input', v);
      const opt = this.options.find((o) => o.value === v);
      const displayText = opt ? this.getItemText(opt) : '';
      this.$emit('update:text', displayText);
    },
    handleInput(v) {
      clearTimeout(this.typingBuffer);
      this.typingBuffer = null;
      this.isTyping = true;
      this.searchingInput = v;
      this.$emit('update:text', v);

      this.typingBuffer = setTimeout(() => {
        this.isTyping = false;
        this.doAutocompleteSearch();
      }, 400);
    },

    async doAutocompleteSearch() {
      this.isSerching = true;

      let items = [];
      const Result = await this.api({
        query: this.searchingInput,
        limit: this.limit
      });

      if (!Result.error) {
        if (Array.isArray(Result)) {
          items = Result;
        } else if (Result.items && Array.isArray(Result.items)) {
          items = Result.items;
        }

        this.options = items.map((el) => {
          const rawText = el.name || el.note || el[this.textName];
          const mapVal = el[this.mapKeyField] ?? rawText;
          let textKey =
            this.textKeyMap && (this.textKeyMap[mapVal] ?? (el.code && this.textKeyMap[el.code]));
          return {
            text: textKey ? undefined : rawText,
            textKey: textKey || undefined,
            value: el[this.keyName]
          };
        })
          .filter(({ value }) =>
            Array.isArray(this.exclude)
              ? !this.exclude.includes(value)
              : value !== this.exclude
          );

        if (this.default) {
          const v = this.options.find(({ value }) => this.default === value);
          if (v) this.$emit('input', v.value);
        }
      }

      this.isSerching = false;
    }
  }
};
</script>

<style lang="scss" scoped>
//
</style>